import { type FlagType, typeSchema } from '../types';

export function assertFlagType(name: unknown): asserts name is FlagType {
  typeSchema.parse(name);
}
